import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Grid, Panel} from 'react-bootstrap';
import {FormErrors} from '../common';
import InitializeAccountProfileForm from './InitializeAccountProfileForm';
import {validateInvitation} from 'api';
import {formatErrors} from 'actions/errors';
import {setAuthInfo, removeAuthInfo, setCurrentAccount, updateProfile} from 'actions/account';

class AcceptInvitation extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    removeAuthInfo();
    this.state = {
      token: null,
      user: null,
      invitationId: null,
      errors: {},
    };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentDidMount() {
    const {formatErrors} = this.props;
    validateInvitation()
      .then(({token, user, invitationId}) => {
        this.setState({
          token,
          user,
          invitationId,
        });
      })
      .catch((err) => formatErrors(err));
  }

  handleFormSubmit(data) {
    const {updateProfile, formatErrors} = this.props;
    const {
      router: {
        history: {push},
      },
    } = this.context;
    const {token, user, invitationId} = this.state;
    setAuthInfo(token);
    setCurrentAccount(user);

    return updateProfile({
      ...data,
      invitationId,
    })
      .then(() => push('/'))
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  render() {
    const {token, errors} = this.state;
    return (
      token && (
        <div className="invitation-acceptation">
          <Grid className="content-box">
            <Panel>
              <h3 className="section-header">
                <div className="section-title">Accept Invitation</div>
              </h3>
              <FormErrors errors={errors} />
              <InitializeAccountProfileForm onSubmit={this.handleFormSubmit} />
            </Panel>
          </Grid>
        </div>
      )
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  setCurrentAccount: (...args) => dispatch(setCurrentAccount(...args)),
  updateProfile: (...args) => dispatch(updateProfile(...args)),
});

export default connect(null, mapDispatchToProps)(AcceptInvitation);
